import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { provideFluentDesignSystem, allComponents } from '@fluentui/web-components';

import { AppModule } from './app/app.module';
import {
  consumeClinicSignOutCookie,
  handleClinicLoggedOutLandingPage,
} from './app/core/utils/cross-app-logout.util';
import { purgeLegacyWorksheetLocalStorageKeys } from './app/pages/worksheet/worksheet-local-storage-purge';
import { environment } from './environments/environment';

purgeLegacyWorksheetLocalStorageKeys();

if (handleClinicLoggedOutLandingPage()) {
  // Logout relay redirect in progress — skip bootstrapping this load.
} else {
// Stale he_clinic_signout must never influence SSO redirects to dev-auth.
consumeClinicSignOutCookie();

// Register Fluent UI Web Components globally
provideFluentDesignSystem().register(allComponents);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
}
